module.exports = __webpack_public_path__ + "img/comment3.bda8b429.png";